var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBayerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_light",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "54 42 523 116",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#11374F;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,42.3h28.7l21.7,63.8h0.3l20.5-63.8h28.7V135h-19.1V69.3H134L111.3,135H95.6L72.8,70h-0.3V135H53.5V42.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201,143.5c-4,10.8-10.4,15.2-23.1,15.2c-3.8,0-7.5-0.3-11.3-0.6v-15.2c3.5,0.3,7.1,0.8,10.8,0.6 c6.4-0.6,8.4-7.3,6.4-12.6l-23.6-63h19.7l15.2,46h0.3l14.7-46h19.1L201,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.3,42.3h43.6c17.7,0,29.6,5.7,29.6,23c0,9.1-4.5,15.5-12.6,19.3c11.3,3.2,17,11.9,17,23.5 c0,18.8-16,26.9-32.7,26.9h-44.9V42.3z M257.7,79.9h20.6c7.1,0,12.5-3.2,12.5-11c0-8.8-6.8-10.6-14-10.6h-19.1V79.9z M257.7,119.2 h21.8c8.1,0,15.1-2.6,15.1-12.2c0-9.5-6-13.2-14.7-13.2h-22.2V119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.1,88.6c1-17.3,16.5-22.5,31.6-22.5c13.4,0,29.5,3,29.5,19.1v34.9c0,6.1,0.6,12.2,2.3,14.9h-18.7 c-0.6-2.1-1.2-4.3-1.3-6.5c-5.8,6.1-14.4,8.3-22.6,8.3c-12.7,0-22.9-6.4-22.9-20.1c0-15.2,11.4-18.8,22.9-20.4 c11.3-1.7,21.8-1.3,21.8-8.8c0-7.9-5.5-9.1-11.9-9.1c-7,0-11.6,2.9-12.2,10.1H324.1z M366.7,102.2c-3.1,2.7-9.6,2.9-15.3,3.9 c-5.7,1.2-10.9,3.1-10.9,9.9c0,6.9,5.3,8.6,11.3,8.6c14.4,0,14.9-11.4,14.9-15.5V102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.4,143.5c-4,10.8-10.4,15.2-23.1,15.2c-3.8,0-7.5-0.3-11.3-0.6v-15.2c3.5,0.3,7.1,0.8,10.8,0.6 c6.4-0.6,8.4-7.3,6.4-12.6l-23.6-63h19.7l15.2,46h0.3l14.7-46h19.1L430.4,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.4,106c0.5,11.7,6.2,17,16.5,17c7.4,0,13.4-4.5,14.5-8.7h16.2c-5.2,15.8-16.2,22.6-31.4,22.6 c-21.2,0-34.3-14.5-34.3-35.3c0-20.1,13.9-35.4,34.3-35.4c22.9,0,33.9,19.2,32.6,39.9H476.4z M506.4,94.3 c-1.7-9.3-5.7-14.3-14.7-14.3c-11.7,0-15.1,9.1-15.3,14.3H506.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533.7,67.9h17.5v12.5h0.3c3.4-8.4,12.5-14.3,21.4-14.3c1.3,0,2.9,0.3,4,0.6v17.1c-1.7-0.4-4.4-0.6-6.6-0.6 c-13.5,0-18.2,9.7-18.2,21.6V135h-18.4V67.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBayerLight);
export default __webpack_public_path__ + "static/media/my-bayer-light.a92c1fad92687e4d3d599fc024ac3b2b.svg";
export { ForwardRef as ReactComponent };